/** Safe to send through the worker boundary: never contains a signed URL. */
export class ParquetRequestError extends Error {
  constructor(public readonly status?: number) {
    super(status === undefined ? 'Parquet network request failed' : `Parquet request failed (${status})`);
    this.name = 'ParquetRequestError';
  }
}

export const canRefreshParquetUrl = (error: unknown): boolean =>
  error instanceof ParquetRequestError &&
  (error.status === undefined || error.status === 400 || error.status === 401 || error.status === 403);

export const fetchParquetResponse: typeof fetch = async (input, init) => {
  let response: Response;
  try {
    response = await fetch(input, init);
  } catch (error) {
    if (error instanceof Error && error.name === 'AbortError') throw error;
    throw new ParquetRequestError();
  }
  if (!response.ok) throw new ParquetRequestError(response.status);
  return response;
};
